// 画布-地址详情侧栏 文案 - 简体中文
export default {
  header: {
    addressDetails: "地址详情",
    contractDetails: "合约详情",
  },
  loading: {
    text: "拼命加载中",
  },
  labels: {
    remark: "备注：",
    none: "暂无",
    otherInfo: "其他信息",
    asset: "资产",
    tradingStatistics: "交易统计",
    transactionAnalysis: "交易分析",
    transactionDetails: "交易明细",
    tradingOpponent: "交易对手",
    labelMissing: "标签缺失",
    dataLabel: "数据标签",
    labelCorrect: "纠错",
    labelTrace: "溯源",
  },
  tooltips: {
    edit: "编辑",
    addToMonitor: "加入监控",
    addToDashboard: "加入看板",
  },
  survey: {
    normal: "普通调证",
    important: "重点调证",
  },
 

  errors: {
    selectHint: "请在画布中选择节点或者交易边可查看数据详情",
    searchHintPrefix:
      "请在顶部搜索框内搜索地址/哈希/调证用户ID\n再选择节点或者交易边可查看数据详情",
    unsupportedChain: "系统暂不支持此链上的数据展示",
    noData: "系统中没有当前地址的交易数据",
    noAddressFound: "没有查出该地址",
    dataNotFound: "未找到符合搜索内容的数据，请修正后重试",
  },
};
